import Image from 'next/image';
import styles from './HowWeWork.module.css';
export function HowWeWork() {
    return (
        <section className="section bgLigtgray">
            <div className="containerFull">
                <h2 className="font26 f600 text000  textCenter fontSM20 mb20">How We<span className="textpink"> Work?</span></h2>
                <span className={`font16 comPletmainbox textCenter ${styles.disPlyblok}`}>Our expert interior designers in Dubai curate original concepts with exquisite craftsmanship to deliver unique design solutions that match your vision.</span>
                <div className="containFull">
                    <div className={styles.weWorkmainbox}>
                        <div className={styles.weWorktiles}>
                            <figure>
                                <Image width={135} height={101} src="/assets/images/meetUs.svg" alt="meetUs" />
                            </figure>
                            <div className={styles.weTiletext}>
                                <h3 className="font18 text000 f600 mb16 lineHeight24 dBCenter fontSM16">Let’s Meet Over Coffee</h3>
                                <p className="font16 lineHeight26 text666 textCenter">A brief chat with us over coffee or even a digital meet-up will help us understand your requirements and your objective.</p>
                            </div>
                        </div>
                        <div className={styles.weWorktiles}>
                            <figure>
                                <Image width={135} height={101} src="/assets/images/scopeofWork.svg" alt="scopeOfWork" />
                            </figure>
                            <div className={styles.weTiletext}>
                                <h3 className="font18 text000 f600 mb16 lineHeight24 dBCenter fontSM16">Defining the Scope of Work</h3>
                                <p className="font16 lineHeight26 text666 textCenter">As the first step, we create a basic outline of the work to be done and discuss the important details with you, from materials and finishes to everything in between.</p>
                            </div>
                        </div>
                        <div className={styles.weWorktiles}>
                            <figure>
                                <Image width={135} height={101} src="/assets/images/sealDeal.svg" alt="sealDeal" />
                            </figure>
                            <div className={styles.weTiletext}>
                                <h3 className="font18 text000 f600 mb16 lineHeight24 dBCenter fontSM16">Finalisation of Agreement</h3>
                                <p className="font16 lineHeight26 text666 textCenter">With the discussions in place, we will finalise the deal. You will need to pay 10% of the total fee as an initial amount. Then, pay 50% of the order value to start the project and the remaining balance before the final handover.</p>
                            </div>
                        </div>
                        <div className={styles.weWorktiles}>
                            <figure>
                                <Image width={135} height={101} src="/assets/images/executions.svg" alt="executions" />
                            </figure>
                            <div className={styles.weTiletext}>
                                <h3 className="font18 text000 f600 mb16 lineHeight24 dBCenter fontSM16">Implementing the Ideas</h3>
                                <p className="font16 lineHeight26 text666 textCenter">As soon as the deal is finalised, our team of interior designers spring into action to finalise the deliverables. We keep you updated at every junction of the process.</p>
                            </div>
                        </div>
                        <div className={styles.weWorktiles}>
                            <figure>
                                <Image width={135} height={101} src="/assets/images/stampofApproval.svg" alt="stampofApproval" />
                            </figure>
                            <div className={styles.weTiletext}>
                                <h3 className="font18 text000 f600 mb16 lineHeight24 dBCenter fontSM16">Finishing Up</h3>
                                <p className="font16 lineHeight26 text666 textCenter">Welcome to your dream home! Now, all you need to do is move in and celebrate.</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    )
}